import React from "react";
import NnSounds from "./NnSounds";
import {} from "reactstrap";

class NnPianoKey extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      octave: props.octave,
      active: props.active
    };

    this.play = this.play.bind(this);
  }

  getLabel(keyname, octave) {
    keyname = keyname || '';
    octave = octave || 4;
    const re = /([ABCDEFG])((s.f)?)/;
    let m = keyname.match(re, "i");
    let label = m ? (m[1].toUpperCase() + (m[2] ? "#" : "")) : "";
    let result = [`'''${label}`, `''${label}`, `'${label}`, `${label}`, `${label}'`, `${label}''`, `${label}'''` ]
    return result[octave];
  }

  render() {
    // TODO use props.active somehow
    return (
      <div className={this.getClassNames()} onClick={this.play}>
        <span className="key-label">{this.getLabel(this.props.note, this.state.octave)}</span>
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.octave !== this.state.octave) {
      this.setState({octave: nextProps.octave})
    }
    if (nextProps.active !== this.state.active) {
      this.setState({active: nextProps.active})
    }
  }

  // concatenate all state values that need to render as class names for this key
  getClassNames() {
    return [
      "piano-key",
      this.props.note,
      this.props.black ? "black" : "white",
      this.state.active ? "active" : ""
    ].join(" ");
  }

  play() {
    NnSounds.play(this.props.note, this.state.octave);
    this.props.onKeyPress(this.props.note);
  }
}
export default NnPianoKey;



// WEBPACK FOOTER //
// ./src/NnPianoKey.js